export default "__VITE_ASSET__PnY9MhyK__"